// extracted by mini-css-extract-plugin
export var author = "header-module--author--iAYq-";
export var backgroundImage = "header-module--background-image--7uNSg";
export var categoriesContainer = "header-module--categories-container--Et6ul";
export var category = "header-module--category--AYMek";
export var data = "header-module--data--sSiTe";
export var innerWrapper = "header-module--inner-wrapper--9RVQZ";
export var mainTitle = "header-module--main-title--RQi87";
export var meta = "header-module--meta--37jh8";
export var readingTime = "header-module--reading-time--JxDw5";
export var singleBlogPostHeader = "header-module--single-blog-post-header--hptsk";